// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/address_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { MultiServiceAddressInfo } from "./address_types.js";

export const protobufPackage = "photon.imessage.v1";

export interface GetAddressInfoRequest {
  address: string;
}

export interface GetAddressInfoResponse {
  info: MultiServiceAddressInfo | undefined;
}

export interface GetFocusStatusRequest {
  address: string;
}

export interface GetFocusStatusResponse {
  /**
   * True when Messages currently shows this address as silenced by Focus.
   * False also covers unknown, not shared, and not silenced.
   */
  isSilencedByFocus: boolean;
}

export interface GetIMessageAvailabilityRequest {
  address: string;
}

export interface GetIMessageAvailabilityResponse {
  isAvailable: boolean;
}

function createBaseGetAddressInfoRequest(): GetAddressInfoRequest {
  return { address: "" };
}

export const GetAddressInfoRequest: MessageFns<GetAddressInfoRequest> = {
  encode(message: GetAddressInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAddressInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAddressInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.address = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAddressInfoRequest {
    return { address: isSet(object.address) ? globalThis.String(object.address) : "" };
  },

  toJSON(message: GetAddressInfoRequest): unknown {
    const obj: any = {};
    if (message.address !== "") {
      obj.address = message.address;
    }
    return obj;
  },

  create(base?: DeepPartial<GetAddressInfoRequest>): GetAddressInfoRequest {
    return GetAddressInfoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetAddressInfoRequest>): GetAddressInfoRequest {
    const message = createBaseGetAddressInfoRequest();
    message.address = object.address ?? "";
    return message;
  },
};

function createBaseGetAddressInfoResponse(): GetAddressInfoResponse {
  return { info: undefined };
}

export const GetAddressInfoResponse: MessageFns<GetAddressInfoResponse> = {
  encode(message: GetAddressInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.info !== undefined) {
      MultiServiceAddressInfo.encode(message.info, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAddressInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAddressInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.info = MultiServiceAddressInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAddressInfoResponse {
    return { info: isSet(object.info) ? MultiServiceAddressInfo.fromJSON(object.info) : undefined };
  },

  toJSON(message: GetAddressInfoResponse): unknown {
    const obj: any = {};
    if (message.info !== undefined) {
      obj.info = MultiServiceAddressInfo.toJSON(message.info);
    }
    return obj;
  },

  create(base?: DeepPartial<GetAddressInfoResponse>): GetAddressInfoResponse {
    return GetAddressInfoResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetAddressInfoResponse>): GetAddressInfoResponse {
    const message = createBaseGetAddressInfoResponse();
    message.info = (object.info !== undefined && object.info !== null)
      ? MultiServiceAddressInfo.fromPartial(object.info)
      : undefined;
    return message;
  },
};

function createBaseGetFocusStatusRequest(): GetFocusStatusRequest {
  return { address: "" };
}

export const GetFocusStatusRequest: MessageFns<GetFocusStatusRequest> = {
  encode(message: GetFocusStatusRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFocusStatusRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFocusStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.address = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFocusStatusRequest {
    return { address: isSet(object.address) ? globalThis.String(object.address) : "" };
  },

  toJSON(message: GetFocusStatusRequest): unknown {
    const obj: any = {};
    if (message.address !== "") {
      obj.address = message.address;
    }
    return obj;
  },

  create(base?: DeepPartial<GetFocusStatusRequest>): GetFocusStatusRequest {
    return GetFocusStatusRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetFocusStatusRequest>): GetFocusStatusRequest {
    const message = createBaseGetFocusStatusRequest();
    message.address = object.address ?? "";
    return message;
  },
};

function createBaseGetFocusStatusResponse(): GetFocusStatusResponse {
  return { isSilencedByFocus: false };
}

export const GetFocusStatusResponse: MessageFns<GetFocusStatusResponse> = {
  encode(message: GetFocusStatusResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isSilencedByFocus !== false) {
      writer.uint32(8).bool(message.isSilencedByFocus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFocusStatusResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFocusStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isSilencedByFocus = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFocusStatusResponse {
    return {
      isSilencedByFocus: isSet(object.isSilencedByFocus)
        ? globalThis.Boolean(object.isSilencedByFocus)
        : isSet(object.is_silenced_by_focus)
        ? globalThis.Boolean(object.is_silenced_by_focus)
        : false,
    };
  },

  toJSON(message: GetFocusStatusResponse): unknown {
    const obj: any = {};
    if (message.isSilencedByFocus !== false) {
      obj.isSilencedByFocus = message.isSilencedByFocus;
    }
    return obj;
  },

  create(base?: DeepPartial<GetFocusStatusResponse>): GetFocusStatusResponse {
    return GetFocusStatusResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetFocusStatusResponse>): GetFocusStatusResponse {
    const message = createBaseGetFocusStatusResponse();
    message.isSilencedByFocus = object.isSilencedByFocus ?? false;
    return message;
  },
};

function createBaseGetIMessageAvailabilityRequest(): GetIMessageAvailabilityRequest {
  return { address: "" };
}

export const GetIMessageAvailabilityRequest: MessageFns<GetIMessageAvailabilityRequest> = {
  encode(message: GetIMessageAvailabilityRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIMessageAvailabilityRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetIMessageAvailabilityRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.address = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetIMessageAvailabilityRequest {
    return { address: isSet(object.address) ? globalThis.String(object.address) : "" };
  },

  toJSON(message: GetIMessageAvailabilityRequest): unknown {
    const obj: any = {};
    if (message.address !== "") {
      obj.address = message.address;
    }
    return obj;
  },

  create(base?: DeepPartial<GetIMessageAvailabilityRequest>): GetIMessageAvailabilityRequest {
    return GetIMessageAvailabilityRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetIMessageAvailabilityRequest>): GetIMessageAvailabilityRequest {
    const message = createBaseGetIMessageAvailabilityRequest();
    message.address = object.address ?? "";
    return message;
  },
};

function createBaseGetIMessageAvailabilityResponse(): GetIMessageAvailabilityResponse {
  return { isAvailable: false };
}

export const GetIMessageAvailabilityResponse: MessageFns<GetIMessageAvailabilityResponse> = {
  encode(message: GetIMessageAvailabilityResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isAvailable !== false) {
      writer.uint32(8).bool(message.isAvailable);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIMessageAvailabilityResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetIMessageAvailabilityResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isAvailable = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetIMessageAvailabilityResponse {
    return {
      isAvailable: isSet(object.isAvailable)
        ? globalThis.Boolean(object.isAvailable)
        : isSet(object.is_available)
        ? globalThis.Boolean(object.is_available)
        : false,
    };
  },

  toJSON(message: GetIMessageAvailabilityResponse): unknown {
    const obj: any = {};
    if (message.isAvailable !== false) {
      obj.isAvailable = message.isAvailable;
    }
    return obj;
  },

  create(base?: DeepPartial<GetIMessageAvailabilityResponse>): GetIMessageAvailabilityResponse {
    return GetIMessageAvailabilityResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetIMessageAvailabilityResponse>): GetIMessageAvailabilityResponse {
    const message = createBaseGetIMessageAvailabilityResponse();
    message.isAvailable = object.isAvailable ?? false;
    return message;
  },
};

/**
 * All RPCs share the same `address` query rules:
 *
 *   - accept an E.164 phone number such as `+14155550123`
 *   - accept a full email such as `alice@example.com`
 *   - the server trims whitespace and lowercases email queries before lookup
 *     or external availability checks
 *   - empty or malformed inputs are rejected with `INVALID_ARGUMENT`
 */
export type AddressServiceDefinition = typeof AddressServiceDefinition;
export const AddressServiceDefinition = {
  name: "AddressService",
  fullName: "photon.imessage.v1.AddressService",
  methods: {
    /**
     * Returns services seen and country for the address.
     *
     * Errors: NOT_FOUND when the address has never been seen in this device's
     * iMessage history.
     */
    getAddressInfo: {
      name: "GetAddressInfo",
      requestType: GetAddressInfoRequest as typeof GetAddressInfoRequest,
      requestStream: false,
      responseType: GetAddressInfoResponse as typeof GetAddressInfoResponse,
      responseStream: false,
      options: {},
    },
    /** Returns whether Messages currently reports this address as Focus-silenced. */
    getFocusStatus: {
      name: "GetFocusStatus",
      requestType: GetFocusStatusRequest as typeof GetFocusStatusRequest,
      requestStream: false,
      responseType: GetFocusStatusResponse as typeof GetFocusStatusResponse,
      responseStream: false,
      options: {},
    },
    /** Returns whether the address is reachable via iMessage at query time. */
    getIMessageAvailability: {
      name: "GetIMessageAvailability",
      requestType: GetIMessageAvailabilityRequest as typeof GetIMessageAvailabilityRequest,
      requestStream: false,
      responseType: GetIMessageAvailabilityResponse as typeof GetIMessageAvailabilityResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface AddressServiceImplementation<CallContextExt = {}> {
  /**
   * Returns services seen and country for the address.
   *
   * Errors: NOT_FOUND when the address has never been seen in this device's
   * iMessage history.
   */
  getAddressInfo(
    request: GetAddressInfoRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetAddressInfoResponse>>;
  /** Returns whether Messages currently reports this address as Focus-silenced. */
  getFocusStatus(
    request: GetFocusStatusRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetFocusStatusResponse>>;
  /** Returns whether the address is reachable via iMessage at query time. */
  getIMessageAvailability(
    request: GetIMessageAvailabilityRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetIMessageAvailabilityResponse>>;
}

export interface AddressServiceClient<CallOptionsExt = {}> {
  /**
   * Returns services seen and country for the address.
   *
   * Errors: NOT_FOUND when the address has never been seen in this device's
   * iMessage history.
   */
  getAddressInfo(
    request: DeepPartial<GetAddressInfoRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetAddressInfoResponse>;
  /** Returns whether Messages currently reports this address as Focus-silenced. */
  getFocusStatus(
    request: DeepPartial<GetFocusStatusRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetFocusStatusResponse>;
  /** Returns whether the address is reachable via iMessage at query time. */
  getIMessageAvailability(
    request: DeepPartial<GetIMessageAvailabilityRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetIMessageAvailabilityResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
